import React from "react";
import InstagramGallery from "../components/instagram-gallery";
import NavFooter from "../components/nav-footer";
import FooterContent from "../components/footer-content";

export default function StandardPage({
  children,
  header,
  className,
  gallery = <InstagramGallery />,
}) {
  return (
    <div className={`min-h-screen flex flex-col ${className}`}>
      {header}
      <main>{children}</main>
      <div className="flex-grow" />
      <footer>
        {gallery}
        <FooterContent className="py-8" />
        <NavFooter />
      </footer>
    </div>
  );
}
